import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import AuthService from "./auth.service";
import {NotificationsService} from 'angular2-notifications';
import * as adblockDetect from 'adblock-detect';


@Injectable()
class AdBlockService implements CanActivate {
    constructor(private authService: AuthService,
                private notificationsService: NotificationsService
    ) {

    }

    public canActivate(): Promise<boolean> {
        return new Promise(((resolve) => {
            adblockDetect((isAdBlockDetected) => {
                if (isAdBlockDetected) {
                    console.log('Ad blocker is detected');
                    this.notificationsService.error('Ad Block detected!', 'You cannot use Map Survey with Ad Block enabled. Please disable it and reload the page. Thank you!');
                    this.authService.logout(false);
                    resolve(false)
                } else {
                    console.log('Ad blocker is not detected');
                    resolve(true)
                }
            }, {
                testRuns: 1
            });
        }))
    }

}

export default AdBlockService;






// WEBPACK FOOTER //
// ./src/app/services/adBlock.service.ts